<template>
    <div class="form-group"
         :id="fieldName + '-select-field'"
         :class="{ 'has-error': form.errors.has(this.fieldConfig.value_field) }">
        <label class="form-control-label" v-if="showLabel">
            <span v-html="fieldConfig.label"></span>
            <span class="required" v-if="fieldConfig.field_extra.required">&nbsp;&nbsp;(*)</span>
            <span v-if="withHelpIcon" :class="fieldConfig.field_extra.withIcon" :title="fieldConfig.field_extra.helpText"></span>
        </label>

        <multi-select
            :value="optionValue"
            :options="fieldConfig.options"
            :track-by="fieldConfig.optionValueField"
            :label="fieldConfig.optionLabelField"
            :placeholder="fieldConfig.label"
            @input="updateValue"
            class="form-control"
            :disabled="fieldConfig.disabled === 1"
        ></multi-select>
        <span class="help-block" v-if="form.errors.has(this.fieldConfig.value_field)">
            {{ form.errors.get(this.fieldConfig.value_field, true) }}
        </span>
        <div v-if="hasHelpText">
            <span v-html="fieldConfig.field_extra.helpText"></span>
        </div>

    </div>
</template>
<script>
    import MultiSelect from 'vue-multiselect';
    import { FormFieldMixin, HasOptionsMixin } from 'laravel-vue-forms';
    export default {

        mixins: [
            FormFieldMixin,
            HasOptionsMixin
        ],


        components: {
            MultiSelect
        },

        created() {
            this.$on('options-updated', function() {
                if(this.form.data.operating_hours === null && this.optionValue !== '' && this.optionValue !== null) {
                    this.updateOperatingHours(this.optionValue);
                }
            })
        },

        methods: {
            updateValue(value) {
                this.form.errors.clear(this.fieldConfig.value_field);

                let operatingHoursField = this.form.formConfig.fields.find(field => {
                    return field.value_field === 'operating_hours'
                });
                if(value) {

                    if(operatingHoursField) {
                        this.updateOperatingHours(value);
                    }

                    this.$emit('input', value[this.fieldConfig.optionValueField]);
                } else {

                    if(operatingHoursField) {
                        this.form.data.operating_hours = null;
                    }

                    this.$emit('input', null)
                }
            },
            updateOperatingHours(value) {
                this.form.data.operating_hours = value.lighting_reference.fixture_annual_operating_hours;
            }
        }
    }

</script>
